import { Grid } from "@mui/material";
import { AxiosResponse } from "axios";

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { taxApi } from "../../../api/TaxApi";
import { toDollar } from "../../../utils/dataConverter";
import SummaryCard from "./SummaryCard";

const TaxSummary: React.FC = () => {
  const [t1040, setT1040] = useState<any>(null);
  const [w2s, setW2s] = useState<any[]>([]);
  const [sch1s, setSch1s] = useState<any[]>([]);
  const [schCs, setSchCs] = useState<any[]>([]);
  const { data } = useSelector((state: any) => state.user);
  useEffect(() => {
    get1040();
    getW2();
    getSchedule1();
    getScheduleC();
  }, []);

  const get1040 = async () => {
    try {
      const { data } =
        (await taxApi.fetch1040FormDetails()) as AxiosResponse<any>;
      setT1040(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getW2 = async () => {
    try {
      const { data } =
        (await taxApi.fetchW2FormDetails()) as AxiosResponse<any>;
      setW2s(data.tax_data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getSchedule1 = async () => {
    try {
      const { data } =
        (await taxApi.fetchSchedule1FormDetails()) as AxiosResponse<any>;
      setSch1s(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getScheduleC = async () => {
    try {
      const { data } =
        (await taxApi.fetchScheduleCFormDetails()) as AxiosResponse<any>;
      setSchCs(data.tax_data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const onDownloadFile = (file_name: string) => async () => {
    try {
      await taxApi.downloadFile({
        file_name,
        user_id: data.id,
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div>
      <h2 className='title'>Tax Summary</h2>
      {/* 1040 Forms */}
      <SummaryCard
        title={t1040?.s3_file_name ?? ""}
        subTitle="1040 U.S. Individual Tax Return"
        onDownload={onDownloadFile(t1040?.s3_file_name ?? "")}
      >
        <div className={'form-static'}>
          <label className={'form-static-title'}>
            1 Wages, salaries, tips, etc.
          </label>
          <label className={'form-static-value'}>
            {toDollar(t1040?.wages_salary_tips)}
          </label>
        </div>
        <div className={'form-static'}>
          <label className={'form-static-title'}>
            8 Other income from Schedule 1
          </label>
          <label className={'form-static-value'}>
            {toDollar(t1040?.other_income)}
          </label>
        </div>
      </SummaryCard>
      {/* W2 forms */}
      {w2s.map((w2) => (
        <SummaryCard
          key={w2.id}
          title={w2.s3_file_name}
          subTitle="W-2 Individual Tax Statement"
          onDownload={onDownloadFile(w2.s3_file_name)}
        >
          <div className={'form-static'}>
            <label className={'form-static-title'}>
              Employer’s Name, Address, and Zip Code
            </label>
            {w2.employer_name_address
              ?.split("\n")
              .map((address: string, index: number) => (
                <label key={index} className={'form-static-value'}>
                  {address}
                </label>
              ))}
          </div>
          <div className={'form-static'}>
            <label className={'form-static-title'}>
              5 Wages, tips, other comp.
            </label>
            <label className={'form-static-value'}>
              {toDollar(w2.wages_tips_other_comp_box1)}
            </label>
          </div>
          {w2.taxw2formtrans.map((trans: any) => (
            <Grid container key={`${w2.id}_${trans.id}`}>
              <Grid
                className={'form-static'}
                size={{
                  xs: 6,
                  md: 4
                }}>
                <label className={'form-static-title'}>
                  18 Local wages, tips, etc.
                </label>
                <label className={'form-static-value'}>
                  {toDollar(trans.local_wages_tips)}
                </label>
              </Grid>
              <Grid
                className={'form-static'}
                size={{
                  xs: 6,
                  md: 4
                }}>
                <label className={'form-static-title'}>
                  19 Local Income Tax
                </label>
                <label className={'form-static-value'}>
                  {toDollar(trans.local_income_tax)}
                </label>
              </Grid>
              <Grid
                className={'form-static'}
                size={{
                  xs: 12,
                  md: 4
                }}>
                <label className={'form-static-title'}>
                  20 Locality name
                </label>
                <label className={'form-static-value'}>
                  {trans.locality_name}
                </label>
              </Grid>
            </Grid>
          ))}
        </SummaryCard>
      ))}
      {/* Schedule 1 forms */}
      {sch1s.map((sch1) => (
        <SummaryCard
          key={sch1.id}
          title={sch1.s3_file_name}
          subTitle="Additional Income and Adjustments to Income"
          onDownload={onDownloadFile(sch1.s3_file_name)}
        >
          <div className={'form-static'}>
            <label className={'form-static-title'}>
              3 Business income or (loss)
            </label>
            <label className={'form-static-value'}>
              {toDollar(sch1.sch_1_field_3)}
            </label>
          </div>
          <div className={'form-static'}>
            <label className={'form-static-title'}>
              6 Farm income or (loss)
            </label>
            <label className={'form-static-value'}>
              {toDollar(sch1.sch_1_field_6)}
            </label>
          </div>
          <div className={'form-static'}>
            <label className={'form-static-title'}>
              8 Other income amount
            </label>
            <label className={'form-static-value'}>
              {toDollar(sch1.sch_1_field_8)}
            </label>
          </div>
        </SummaryCard>
      ))}
      {/* Schedule C forms */}
      {schCs.map((schC) => (
        <SummaryCard
          key={schC.id}
          title={schC.s3_file_name}
          subTitle="Profit or Loss From Business"
          onDownload={schC.s3_file_name}
        >
          <div className={'form-static'}>
            <label className={'form-static-title'}>Business Address</label>
            <label className={'form-static-value'}>
              {schC.business_address}
            </label>
          </div>
          <div className={'form-static'}>
            <label className={'form-static-title'}>
              31 Net Profit or Loss
            </label>
            <label className={'form-static-value'}>
              {toDollar(schC.sch_c_field_31)}
            </label>
          </div>
        </SummaryCard>
      ))}
    </div>
  );
};

export default TaxSummary;

/*
const browserStyles = makeStyles(() =>
  createStyles({
    title: {
      fontSize: 24,
      fontWeight: 700,
      color: "#0F7580",
    },
    formStatic: {
      padding: 12,
      display: "flex",
      flexDirection: "column",
    },
    formStaticTitle: {
      fontSize: 12,
      fontWeight: 700,
    },
    formStaticValue: {
      fontSize: 16,
    },
  })
);
*/